import { mainBackendApi } from '@/services'
import type { OrganizationInfo } from './types'

export const OrganizationService = mainBackendApi.injectEndpoints({
	endpoints: build => ({
		getOrganizationInfo: build.query<OrganizationInfo, void>({
			query: () => ({
				url: '/client/organization/info',
				method: 'GET',
			}),
		}),
	}),
})
